import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Order, OneDotOrderStatus } from 'src/app/core/models';
import { ResponsiveUtilsService } from '../../core/services';
import { FormatDatePipe } from 'src/app/core/utils/pipes';
@Component({
  selector: 'app-orders-list',
  templateUrl: './orders-list.component.html',
  styleUrls: ['./orders-list.component.scss'],
})
export class OrdersListComponent {
  @Input() orders: Order[] = [];
  @Input() emptyMessageTitle: string = '';
  @Input() emptyMessage: string = '';
  @Input() hasActionNeeded: boolean = false;
  @Input() hasLoadMore: boolean = false;
  @Input() loadMoreOrders: () => void = () => {};
  @Input() isLoadingMoreOrders: boolean = false;

  // Make enum available to the template
  OneDotOrderStatus = OneDotOrderStatus;

  isTouchDevice$ = this.responsiveUtils.isTouchDevice();
  isBelowXl$ = this.responsiveUtils.isBelowXl();
  isBelowPrime$ = this.responsiveUtils.isBelowPrime();
  formatDatePipe = new FormatDatePipe();

  constructor(private router: Router, private responsiveUtils: ResponsiveUtilsService) {}

  goToAuthorizeOrder(orderId: number) {
    this.router.navigate(['/orders', orderId, 'authorize']);
  }

  goToTrackOrder(trackingUrl: string) {
    window.open(trackingUrl, '_blank');
  }

  hideOrderLink(order: Order): boolean {
    return !order.isShipment || order.needsAuthorization || order.isFutureOrder;
  }

  goToPayment(orderId: number): void {
    if (orderId && !isNaN(orderId)) {
      this.router.navigate(['/orders', orderId, 'authorize', 'make-payment']);
    } else {
      console.error('Invalid orderId:', orderId);
    }
  }
}
